import * as layerOps from '../api/Layers/layer-operations';
import { LAYER_SUBTYPES } from '../api/Layers/Layers';

const WMS_DEFAULT_FIELD = 'wms:';

/**
 * Creates the URL for a layer UTF Grid.
 *
 * @param {object} layer - The layer object.
 * @returns {string} The URL of the UTF Grid.
 * @throws {Error} If something goes wrong.
 */

const getUTFGridURL = layer => {
  const url = layerOps.getURL(layer);
  const subType = layerOps.getSubType(layer);

  let utfGridURL = '';

  if (LAYER_SUBTYPES.TMS === subType)
    utfGridURL = `${url.substring(0, url.indexOf('.png'))}.utfgrid`;

  if (LAYER_SUBTYPES.WMS === subType) {
    const layerNames = layerOps.getWMSLayerNames(layer);
    const urlArray = url.split('/');
    let field = `${urlArray[4]}:`;
    if (field === WMS_DEFAULT_FIELD) field = '';
    utfGridURL = `${urlArray[0]}//${urlArray[2]}/geoserver/gwc/service/tms/1.0.0/${field}${layerNames}@EPSG:900913@png/{z}/{x}/{-y}.utfgrid`;
  }

  return utfGridURL;
};

export default getUTFGridURL;
